/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/

import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import {
getAuth,
onAuthStateChanged,
createUserWithEmailAndPassword,
signInWithEmailAndPassword,
sendPasswordResetEmail,
signOut,
reauthenticateWithCredential,
updateProfile,
updateEmail,
updatePassword,
deleteUser,
EmailAuthProvider} from "firebase/auth";
import "firebase/compat/functions";
import "firebase/compat/app-check";
import "firebase/compat/analytics";
import { Crashlytics } from './helpers';

import {API_KEY, AUTH_DOMAIN, PROJECT_ID,STORAGE_BUCKET,MESSAGING_SENDER_ID, APP_ID, MEASUREMENT_ID, RECAPTCHA_ENTERPRISE_SITE_KEY} from "@env";

const firebaseConfig = {
  apiKey: API_KEY,
  authDomain: AUTH_DOMAIN,
  projectId: PROJECT_ID,
  storageBucket: STORAGE_BUCKET,
  messagingSenderId: MESSAGING_SENDER_ID,
  appId: APP_ID,
  measurementId: MEASUREMENT_ID
};


if (!firebase.apps.length) {
firebase.initializeApp(firebaseConfig);
}

const appCheck = firebase.appCheck();
//--legacy
const functions = firebase.functions();
const firestore = firebase.firestore();
const analytics = firebase.analytics();

//--new
const Functions = firebase.functions();
const Firestore = firebase.firestore();
const Analytics = firebase.analytics();
//Crashlytics is imported from helper


appCheck.activate(
new firebase.appCheck.ReCaptchaEnterpriseProvider(
RECAPTCHA_ENTERPRISE_SITE_KEY
),
true // True = allow auto-refresh
)



export {
functions,
firestore,
analytics,
Functions,
Firestore,
Analytics,
Crashlytics,
getAuth,
onAuthStateChanged,
createUserWithEmailAndPassword,
signInWithEmailAndPassword,
sendPasswordResetEmail,
signOut,
reauthenticateWithCredential,
updateProfile,
updateEmail,
updatePassword,
deleteUser,
EmailAuthProvider};

